// Centralized configuration for admin functionality

// List of admin user IDs with access to admin functionality
export const ADMIN_USER_IDS = [
  "359a23ec-f3a7-4761-aa09-d660bb92016d", // Main admin ID from AdminImpersonation.tsx
  "c97203fd-55ed-4f40-8437-447013c6222d", // Additional admin user
];

// Function to check if a user is an admin
export const isUserAdmin = (userId?: string | null): boolean => {
  if (!userId) return false;
  return ADMIN_USER_IDS.includes(userId);
};

// Admin pages configuration
export const ADMIN_PAGES = [
  {
    key: "admin-pricing",
    title: "Invoice Settings",
    path: "/admin/pricing",
    description: "Manage invoice creation and billing processes",
  },
  {
    key: "admin-tariffs",
    title: "Tariffs Administration",
    path: "/admin/tariffs",
    description: "Manage tariffs for different routes and periods",
  },
  {
    key: "admin-tasks",
    title: "Task Management",
    path: "/admin/tasks",
    description: "Create and manage tasks assigned to team members",
  },
  {
    key: "admin-users",
    title: "User Management",
    path: "/admin/users",
    description: "Manage user accounts, roles and permissions",
  },
  {
    key: "admin-ports",
    title: "Ports Administration",
    path: "/admin/ports",
    description: "Manage origin and destination ports for shipments",
  },
  {
    key: "admin-bookings",
    title: "Bookings",
    path: "/admin/bookings",
    description: "Manage and track customer bookings",
  },
  {
    key: "admin-reports",
    title: "Reports",
    path: "/admin/reports",
    description: "View system reports and analytics",
  },
  {
    key: "admin-containers",
    title: "Containers Administration",
    path: "/admin/containers",
    description: "Manage shipping containers and consolidations",
  },
  {
    key: "admin-invoices",
    title: "Invoices",
    path: "/admin/invoices",
    description: "Manage customer invoices and payments",
  },
  // Add new admin pages here as they are created
];

// Helper to check if a given path is an admin page
export const isAdminPage = (path: string): boolean => {
  return ADMIN_PAGES.some((page) => path.startsWith(page.path));
}; 